import axios from 'axios';

export default class ScheduleResource {
  resource(subjectID) {
    return axios.get('/api/resources/'+subjectID);
  }

  currentSchedule() {
    return axios.get('/api/current-schedule');
  }

  dateTimes(lectureTypeID) {
    const param = lectureTypeID ? '/' + lectureTypeID : '';

    return axios.get('/api/date-times' + param);
  }

  getComponents(){
    return axios.get('/api/master-components/getComponents')
  }


  uploadFiles(data){
    return axios.post('/api/master-components/uploadFiles',data,{
        headers: {
          'Content-Type': 'multipart/form-data'
        }})
  }
  
  getFiles(){
    return axios.get('/api/master-components/getFiles')
  }

  downloadFile(filename){
    return axios.post('/api/master-components/downloadFile',{filename},{responseType:'blob'})
  }
  changeEngLevel(students_ret_tempID,newSubjectID){
       return axios.post('/api/registration/changeEngLevel',{students_ret_tempID,newSubjectID})
  }

  saveAgreements(personalData,mediaMaterials){

      return axios.post('/api/international-agreements/saveInternationalAgreement',{personalData,mediaMaterials})

  }
getAvailableDatesAndTimes(branch,timeType){
  return axios.post('/api/international-agreements/getAvailableDatesAndTimes',{branch,timeType})
}


saveChosenDateAndTime(selectedDate , selectedTime,selectedBranch,timeType){

  return axios.post('/api/international-agreements/saveChosenDateAndTime',{selectedDate , selectedTime,selectedBranch,timeType})

}

alreadyChosenTimes(timeType){
  return axios.get('/api/international-agreements/alreadyChosenTimes?timeType='+timeType)
}

removeChosenTime(id){
  return axios.post('/api/international-agreements/removeChosenTime',{id})
}

getInternationalData(){
  return axios.get('/api/international-agreements/getInternationalData')
}

approveContract(id){
  return axios.post('/api/international-agreements/approveContract',{id})
}

}
